export const FoodItemStatus = {
    AVAILABLE: "فعال",
}
